import { RootState } from '../store';

export const admobSelector = (state: RootState) => state.admob;
